import {SystemPopupView} from "@gongxigames/framework/slotCommon/modules/systemPopupsManager";
import {FlexBoxComponent, ReactButton, RichText} from '@gongxigames/framework/core/fragments/react';
import React from 'react';

export type AutoplayOptionsPopupComponentProps = {
    onClickNo: () => void;
    onClickYes: () => void;
    betFormatedValue: string;
    wagerFormatedValue: string;
    autoplaySpins: number;
};

const width = 1510;
const gapBetweenElements = 50;
const padding = {top: 80, left: 80, bottom: 80, right: 80};
const horizontalPaddingSum = padding.left + padding.right;
const widthWithoutPadding = width - horizontalPaddingSum;
const buttonProperty = {
    horizontalPadding: 45,
    verticalPadding: 25,
    backgroundColor: 0x000000,
    borderColor: 0x9e9e9e,
    borderThickness: 5,
    round: 40,
    width: widthWithoutPadding / 2,
    textStyleId: 'AutoplayPopupConfirmationTitle'
}

export class AutoplayConfirmationPopupComponent extends React.Component<AutoplayOptionsPopupComponentProps> {
    render(): JSX.Element {
        const {
            onClickNo,
            onClickYes,
            autoplaySpins,
            betFormatedValue,
            wagerFormatedValue,
        } = this.props;

        return (
            <SystemPopupView
                titleEnabled={false}
                title={'autoplayConfirmationPopup'}
                closeButtonEnabled={false}
                onClickClose={onClickNo}
                gapBetweenElements={gapBetweenElements}
                width={width}
            >
                <FlexBoxComponent
                    name={'SystemPopupView-content'}
                    direction={'column'}
                    debug={false}
                    padding={padding}
                    gap={gapBetweenElements}
                    justifyContent={'center'}
                    alignItems={'center'}
                >
                    <RichText id={'autoplayStart'} style={'AutoplayPopupConfirmationTitle'}
                              maxWidth={widthWithoutPadding} resolution={1}/>
                    <RichText
                        id={'autoplayStartConfirmationText'}
                        style={'AutoplayPopupConfirmationText'}
                        values={{wager: wagerFormatedValue, bet: betFormatedValue, rounds: autoplaySpins}}
                        maxWidth={widthWithoutPadding} resolution={1}
                    />

                    <FlexBoxComponent
                        name={'AutoplayConfirmationButtons'}
                        containerWidth={widthWithoutPadding}
                        direction={'row'}
                        gap={gapBetweenElements}
                    >
                        <ReactButton
                            {...buttonProperty}
                            name={'noButton'}
                            textId={'buyFeaturePopupNoText'}
                            onClick={onClickNo}
                        />
                        <ReactButton
                            {...buttonProperty}
                            name={'yesButton'}
                            textId={'buyFeaturePopupYesText'}
                            onClick={onClickYes}
                        />
                    </FlexBoxComponent>
                </FlexBoxComponent>
            </SystemPopupView>
        );
    }
}
